<template>
  <div
    class="tab-pane fade"
    :class="{ active: 'Transfers' === activeMenuSelection, show: 'Transfers' === activeMenuSelection }"
    id="Transfers"
    role="tabpanel"
    aria-labelledby="Transfers-tab"
  >
    <div class="card h-100">
      <div class="card-body">
        <div class="container" style="background-color: white">
          <div class="row">
            <div class="col-sm-10">
              <div class="collapse" :class="{ show: showFilters }" id="collapseTransfersFilters">
                <div class="card card-body wallet-filter-panel">
                  <h5 class="card-title">{{ t("filtersLabel") }}</h5>
                  <label for="filterTransfersByType">{{ t("typeLabel") }}</label>
                  <select id="filterTransfersByType" class="form-select form-select-sm mb15" v-model="selectedType">
                    <option value="0">{{ t("allOrderTypesLabel") }}</option>
                    <option value="1">{{ t("incomingLabel") }}</option>
                    <option value="2">{{ t("outgoingLabel") }}</option>
                  </select>
                  <label for="filterByTransferPeriod">{{ t("periodLabel") }}</label>
                  <select id="filterByTransferPeriod" class="form-select form-select-sm mb15" v-model="selectedPeriod">
                    <option value="0">{{ t("thisMonthLabel") }}</option>
                    <option value="1">{{ t("past3MonthLabel") }}</option>
                    <option value="2">{{ t("past6MonthLabel") }}</option>
                    <option value="3">{{ t("pastYearLabel") }}</option>
                    <option value="4">YTD</option>
                    <option value="5">{{ t("fromDateLabel") }}</option>
                  </select>
                  <Datepicker
                    class="mb15"
                    v-if="5 === parseInt(filterTransfersByPeriod)"
                    v-model="selectedDate"
                    format="yyyy-MM-dd"
                    placeholder="yyyy-mm-dd"
                    :minDate="new Date(minDateForWallet)"
                    :maxDate="new Date()"
                    showNowButton
                  />
                  <button type="button" class="btn btn-primary w-100" @click.prevent="$emit('reset-filters')">
                    {{ t("clearLabel") }}
                  </button>
                </div>
              </div>
              <div class="collapse" :class="{ show: showSorting }" id="collapseTransfersSorting">
                <div class="card card-body wallet-filter-panel">
                  <label for="sortingTransfers">{{ t("sortingLabel") }}</label>
                  <select id="sortingTransfers" class="form-select form-select-sm mb15" v-model="selectedSort">
                    <option value="0">{{ t("sortDateAscLabel") }}</option>
                    <option value="1">{{ t("sortDateDescLabel") }}</option>
                    <option value="2">{{ t("sortSymbolAscLabel") }}</option>
                    <option value="3">{{ t("sortSymbolDescLabel") }}</option>
                    <option value="4">{{ t("sortNameAscLabel") }}</option>
                    <option value="5">{{ t("sortNameDescLabel") }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-sm-2">
              <div class="wallet-tab-actions">
                <button
                  type="button"
                  class="btn btn-link"
                  :class="{ active: showFilters }"
                  :aria-expanded="showTransfersFilters"
                  aria-controls="collapseTransfersFilters"
                  @click.prevent="toggleFilters"
                >
                  <i class="icon ion-md-options"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-link"
                  :class="{ active: showSorting }"
                  :aria-expanded="showTransfersSorting"
                  aria-controls="collapseTransfersSorting"
                  @click.prevent="toggleSorting"
                >
                  <i class="icon ion-md-reorder"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="wallet-history">
          <div v-if="loading" class="wallet-history-loading">
            <Preloader />
          </div>
          <div v-else-if="1200 < windowsWidth" class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>{{ t("timestampLabel") }}</th>
                  <th>{{ t("typeLabel") }}</th>
                  <th>{{ t("codeLabel") }}</th>
                  <th>{{ t("nameLabel") }}</th>
                  <th>{{ t("exchangeLabel") }}</th>
                  <th class="price-data">{{ t("quantityLabel") }}</th>
                  <th>{{ t("segmentLabel") }}</th>
                  <th class="price-data">{{ t("priceLabel") }}</th>
                  <th class="price-data">{{ t("totalAmountLabel") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(transaction, index) in transfers" :key="index">
                  <td>{{ getDate(transaction.ts) }}</td>
                  <td style="text-align:center">{{ capitalizeFirstLetter(getTransferType(transaction?.tt)) }}</td>
                  <td style="text-align:center">{{ transaction?.sc?.toUpperCase() }}</td>
                  <td>
                    <div v-if="0 === 'BG'.localeCompare(userLanguage)">
                      {{ transaction?.nBG ? transaction?.nBG : transaction?.nEN }}
                    </div>
                    <div v-if="0 === 'EN'.localeCompare(userLanguage)">{{ transaction?.nEN }}</div>
                  </td>
                  <td style="text-align:center">{{ transaction?.xc?.toUpperCase() }}</td>
                  <td class="price-data">{{ parseNumber(transaction?.qty, 0) }}</td>
                  <td style="text-align:center">{{ transaction?.sgm?.toUpperCase() }}</td>
                  <td class="price-data" v-if="2 != getStockTypeId(transaction?.sc, transaction?.xc)">
                    {{ formatTransferValue(transaction?.sp, transaction?.cc).replace(" ", "&nbsp;") }}
                  </td>
                  <td class="price-data" v-else>
                    {{ formatTransferValue(transaction?.sp, "%").replace(" ", "&nbsp;") }}
                  </td>
                  <td class="price-data" v-if="2 != getStockTypeId(transaction?.sc, transaction?.xc)">
                    {{ formatTransferValue(transaction?.pt, transaction?.cc).replace(" ", "&nbsp;") }}
                  </td>
                  <td class="price-data" v-else>
                    {{ formatTransferValue(transaction?.pt, "%").replace(" ", "&nbsp;") }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else v-for="(transaction, index) in transfers" :key="index">
            <div class="card h-100">
              <div class="card-body xsmall-font-size">
                <div class="container p-0">
                  <div class="row justify-content-between">
                    <div class="col-6">
                      {{ getDate(transaction?.ts) }}<br />
                      <strong>{{ transaction?.nEN }}</strong><br />
                      {{ parseNumber(transaction?.qty, 0) }} * {{ transaction?.sc?.toUpperCase() }}@{{ transaction?.xc?.toUpperCase() }}<br />
                      {{ capitalizeFirstLetter(getTransferType(transaction?.tt)) }}<br />
                      {{ t("priceLabel") }}: {{ formatTransferValue(transaction?.sp, transaction?.cc).replace(" ", "&nbsp;") }}<br />
                      {{ t("totalAmountLabel") }}: {{ formatTransferValue(transaction?.pt, transaction?.cc).replace(" ", "&nbsp;") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "@vuepic/vue-datepicker";
import Preloader from "@/components/ui/Preloader.vue";

export default {
  name: "WalletTransfersTab",
  components: {
    Datepicker,
    Preloader
  },
  props: {
    activeMenuSelection: {
      type: String,
      required: true
    },
    transfers: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    windowsWidth: {
      type: Number,
      required: true
    },
    userLanguage: {
      type: String,
      required: true
    },
    minDateForWallet: {
      type: String,
      required: true
    },
    filterSelectedDate: {
      type: [Date, String, Number, Object],
      default: null
    },
    filterTransfersByType: {
      type: [Number, String],
      required: true
    },
    filterTransfersByPeriod: {
      type: [Number, String],
      required: true
    },
    sortTransfers: {
      type: [Number, String],
      required: true
    },
    showTransfersFilters: {
      type: Boolean,
      required: true
    },
    showTransfersSorting: {
      type: Boolean,
      required: true
    },
    translator: {
      type: Function,
      required: true
    },
    priceFormatter: {
      type: Function,
      required: true
    },
    bondsPriceFormatter: {
      type: Function,
      required: true
    },
    numberParser: {
      type: Function,
      required: true
    },
    dateFormatter: {
      type: Function,
      required: true
    },
    capitalizeFormatter: {
      type: Function,
      required: true
    },
    transferTypeFormatter: {
      type: Function,
      required: true
    },
    stockTypeResolver: {
      type: Function,
      required: true
    }
  },
  emits: [
    "update:filterSelectedDate",
    "update:filterTransfersByType",
    "update:filterTransfersByPeriod",
    "update:sortTransfers",
    "update:showTransfersFilters",
    "update:showTransfersSorting",
    "reset-filters"
  ],
  computed: {
    selectedDate: {
      get() {
        return this.filterSelectedDate;
      },
      set(value) {
        this.$emit("update:filterSelectedDate", value);
      }
    },
    selectedType: {
      get() {
        return this.filterTransfersByType;
      },
      set(value) {
        this.$emit("update:filterTransfersByType", value);
      }
    },
    selectedPeriod: {
      get() {
        return this.filterTransfersByPeriod;
      },
      set(value) {
        this.$emit("update:filterTransfersByPeriod", value);
      }
    },
    selectedSort: {
      get() {
        return this.sortTransfers;
      },
      set(value) {
        this.$emit("update:sortTransfers", value);
      }
    },
    showFilters() {
      return true === this.showTransfersFilters;
    },
    showSorting() {
      return true === this.showTransfersSorting;
    }
  },
  methods: {
    t(key, ...args) {
      return this.translator(key, ...args);
    },
    formatPrice(...args) {
      return this.priceFormatter(...args);
    },
    formatBondsPrice(...args) {
      return this.bondsPriceFormatter(...args);
    },
    formatTransferValue(value, currency, autoDigits = null) {
      const numericValue = "number" === typeof value
        ? value
        : "string" === typeof value && "" !== value.trim()
          ? Number(value)
          : NaN;
      if (!Number.isFinite(numericValue) || 0 === numericValue) {
        return "n/a";
      }

      return "%" === currency
        ? this.formatBondsPrice(value)
        : this.formatPrice(value, currency, autoDigits);
    },
    parseNumber(...args) {
      return this.numberParser(...args);
    },
    getDate(...args) {
      return this.dateFormatter(...args);
    },
    capitalizeFirstLetter(...args) {
      return this.capitalizeFormatter(...args);
    },
    getTransferType(...args) {
      return this.transferTypeFormatter(...args);
    },
    getStockTypeId(...args) {
      return this.stockTypeResolver(...args);
    },
    toggleFilters() {
      this.$emit("update:showTransfersFilters", !this.showTransfersFilters);
      this.$emit("update:showTransfersSorting", false);
    },
    toggleSorting() {
      this.$emit("update:showTransfersSorting", !this.showTransfersSorting);
      this.$emit("update:showTransfersFilters", false);
    }
  }
};
</script>

<style scoped>
.wallet-tab-actions {
  display: flex;
  gap: 0.25rem;
  justify-content: flex-end;
}

.wallet-tab-actions .btn-link {
  align-items: center;
  border: 1px solid transparent;
  display: inline-flex;
  justify-content: center;
  min-height: 2rem;
  min-width: 2rem;
  padding: 0.25rem 0.5rem;
}

.wallet-tab-actions .btn-link:focus,
.wallet-tab-actions .btn-link:focus-visible {
  box-shadow: none;
  outline: 0;
}

.wallet-tab-actions .btn-link.active {
  border-color: #0088aa;
}

.wallet-history-loading {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 8rem;
}

.price-data {
  text-align: right;
  white-space: nowrap;
}
</style>
